// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a16564d0","703":"c63b364e","787":"2ced9347"}[chunkId] + ".chunk.js";
};